import React, { useState } from "react";
import { useForm } from "react-hook-form";



const DemoAccountForm = () => {
  const { register, handleSubmit } = useForm();
  const [data, setData] = useState("");


  return (
    <div>
      <div className='flex flex-col lg:flex-row lg:gap-x-[30px] gap-y-[30px] lg:gap-y-0 justify-center items-center mt-5'>
        <form className='flex flex-col mb gap-x-[10px] w-[200px] lg:w-[400px]' id="live" onSubmit={handleSubmit(() => setData(JSON.stringify(data)))}>
          <input className=' p-[7px] flex border border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5' {...register("mtnum")} placeholder="MT4#/MT5#" type='number' required />
          <select className="p-[7px] flex border bg-transparent border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5 font-primary" {...register("category", { required: true })} required>
            <option value=''>MetaTrader Platform</option>
            <option value='MT4'>MT4</option>
            <option value='MT5'>MT5</option>
          </select>
          <input className=' p-[7px] flex border  border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5' {...register("mtnum")} placeholder="MT4#/MT5#" type='number' required />
          {/* <textarea {...register("aboutYou")} placeholder="About you" /> */}
          {/* <p className="text-black">{data}</p> */}

          <button type="submit" className="btn btn-sm space-x-[14px] items-center bg-sky-400  hover:bg-sky-300 hover:text-white justify-center">Submit</button>

        </form>

      </div>
    </div>
  )
}

export default DemoAccountForm
